<template>
    <div class="gap-4">
        <div class="md:w-full text-sm bg-white text-black">
            <div class="border-0 " variant="outlined" rounded="0">
                <div class="px-4 py-4 mb-4 d-flex align-center justify-center gap-3">
                    <i class="flaticon-atm text-xl"></i>
                    <p class="m-0 text-lg font-medium">TopUp with Gift Code:</p>

                    <v-text-field
                        v-model="giftCode"
                        variant="outlined"
                        density="compact"
                        hide-details
                        class="mx-2"
                        style="max-width: 200px;"
                    ></v-text-field>

                    <v-btn
                        class="bg-dark text-light shadow-lg"
                        size="small"
                        @click="handleRedeem"
                    >
                        Redeem
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, defineEmits } from 'vue';
import { useGiftCodeStore, useAlertStore } from "@/stores"

const giftCodeStore = useGiftCodeStore();
const alertStore = useAlertStore();

const buttonDisableFlag = ref(false);
const giftCode = ref('');

const emit = defineEmits(['inInput', 'submit'])

const handleRedeem = () => {
    if(!giftCode.value) {
        alertStore.error("Set the coupon code.")
        return;
    }

    buttonDisableFlag.value = true;
    // Send FormData to server
    giftCodeStore.redeemGiftCode(giftCode.value).then(() => {
        buttonDisableFlag.value = false;
        emit('close');
    });
};
</script>